import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import Loading from 'lib/loading';
import moment from "moment"

const Lojas = () => {

  const colunas = [
    {
      dataField: 'filial_id',
      text: 'Código'
    },
    {
      dataField: 'razao_social',
      text: 'Razão Social'
    },
    {
      dataField: 'fantasia',
      text: 'Fantasia'
    },
    {
      dataField: 'cnpj',
      text: 'CNPJ'
    },
    {
      dataField: 'is_central',
      text: 'Central',
      formatter: (cellContent, row) => {
        if (row.is_central == 'S' ) {
          return <div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">Sim</span></div>
        }else{
          return <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Não</span></div>
        }
      }
    },
    {
      dataField: 'final_integracao',
      text: 'Principal',
      formatter: (cellContent, row) => {
        return (moment(row.final_integracao).format('DD/MM/YYYY HH:mm:ss'))
      }
    },
    {
      dataField: 'final_paralela',
      text: 'Pararela',
      formatter: (cellContent, row) => {
        return (moment(row.final_paralela).format('DD/MM/YYYY HH:mm:ss'))
      }
    },
    {
      dataField: '#',
      text: 'Status',
      formatter: (cellContent, row) => {
        const today = new Date();
        
        const date = today.getFullYear() + '-' + (today.getMonth() + 1).toString().padStart(2, "0") + '-' + today.getDate();
        const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        const agora = date + ' ' + time;

        let diferenca_integracao = (new Date(agora) - new Date(row.final_integracao))
        let diferenca_paralela = (new Date(agora) - new Date(row.final_paralela))

        diferenca_integracao = ((diferenca_integracao / 1000) / 60);
        diferenca_paralela = ((diferenca_paralela / 1000) / 60);

        if ((diferenca_integracao > 20) || (diferenca_paralela > 20)) {
          return (<i className="text-warning fas fa-exclamation-triangle"></i>)
        }else{
          return (<i class="text-success fa fa-check" aria-hidden="true"></i>) 
        } 
      }
    }
  ]

  const { SearchBar } = Search;
  const [loading, setLoading] = useState(true);
  const [listaLoja, setListaLoja] = useState([])

  const listaLojas = () => {
    let lista = []
    const url = rotas.lojas
    try {
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S') {
          lista = ret.lista
          setListaLoja(lista)
        }
        setLoading(false);
      })
      return (lista)

    } catch (err) {

    }
  }

  useEffect(() => {
    const load = loading;
    if (load === true) {
      listaLojas();
    }
  }, [])

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  } else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>LOJAS</CardTitle>
                </CardHeader>
                <CardBody>

                  <ToolkitProvider
                    keyField="filial_id"
                    data={listaLoja}
                    columns={colunas}
                    search
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="12" className="p-0" >
                                <SearchBar
                                  placeholder="Buscar loja..."
                                  style={{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr />

                          <BootstrapTable
                            striped
                            keyField='filial_id'
                            noDataIndication="Nenhum registro encontrado"
                            {...props.baseProps}
                          />
                          <br />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Lojas;